export class Laboratoire {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    libelle: string;
}
